import { TopicDictionaryKey } from "app/topics/util/config/pageDictionary";

import { topicAdditionalInfoDictionary } from "./dictionary";

export const getAdditionalInfo = (id: TopicDictionaryKey) => topicAdditionalInfoDictionary[id];
